import { useEffect, useSyncExternalStore } from "react";
import { getLockboxState, subscribeLockbox, hydrateLockboxStore } from "../state/lockboxStore";

/**
 * @returns {ReturnType<typeof getLockboxState>}
 */
export function useLockbox() {
  return useSyncExternalStore(subscribeLockbox, getLockboxState, getLockboxState);
}

/**
 * Call once at app root to restore lockbox from AsyncStorage.
 */
export function useLockboxHydration() {
  useEffect(() => {
    void hydrateLockboxStore();
  }, []);
}
